import * as Sentry from '@sentry/react';
import { Card } from 'antd';
import React, { useContext, useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Route, Router, Switch } from 'react-router-dom';
import SmartBanner from 'react-smartbanner';
import Cookies from 'universal-cookie';
import '../node_modules/react-smartbanner/dist/main.css';
import { AppContext } from './AppContext';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import App from './app/App';
import { ErrorIcon } from './assets/svg';
import { ROUTES } from './common/constants';
import MaintenancePage from './components/MaintenancePage';
import history from './historyData';
import IosDeviceUdid from './modules/appDetails/IosDeviceUdid';
import PublicPage from './modules/appDetails/PublicPage';
import Login from './modules/auth/Login';
import Logout from './modules/auth/Logout';
import NewUser from './modules/auth/NewUser';
import RefreshToken from './modules/auth/RefreshToken';
import VerifyUser from './modules/auth/VerifyUser';

const TRACKING_ID = process?.env?.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
ReactGA?.initialize(TRACKING_ID);

const MyFallbackComponent = ({ error, componentStack }) => (
  <div className="d-flex flex-vertical align-center">
    <div className="d-flex flex-vertical align-center">
      <ErrorIcon className="mt-10" width="65px" height="90px" />
      <p className="font-xx-large">
        <strong>Oops! An error occured!</strong>
      </p>
      <Card className="width-percent-60">
        <p className="d-flex font-18">
          <strong className="font-large mr-5">Error: </strong>
          <p className="line-24"> {error?.message?.toString()}</p>
        </p>
        <p>
          <strong className="font-large">Stacktrace:</strong>
          <p className="line-24">{componentStack}</p>
        </p>
      </Card>
    </div>
  </div>
);

const Routes = () => {
  const { dispatch } = useContext(AppContext);
  // use this variable from envs so that we can able to run maintenance page on runtime.
  const maintenance = process.env.REACT_APP_MAINTENANCE_ENABLE;
  // eslint-disable-next-line no-undef
  const { pathname } = window?.location;
  useEffect(() => {
    const cookies = new Cookies();
    const loggedInCheckCookie = cookies?.get('isLoggedIn');
    if (!loggedInCheckCookie) {
      // eslint-disable-next-line no-undef
      localStorage?.clear();
      cookies?.set('isLoggedIn', true, { path: '/' });
      dispatch({
        type: 'SET_LOADING',
        data: false
      });
      // eslint-disable-next-line no-undef
      window?.location?.reload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    ReactGA?.send({
      hitType: 'pageview',
      page: pathname
    });
  }, [pathname]);

  return (
    <Sentry.ErrorBoundary fallback={MyFallbackComponent}>
      <SmartBanner title="AppsOnAir" author="Logicwind Technologies LLP" />
      <Router history={history}>
        {maintenance === 'true' ? (
          <MaintenancePage />
        ) : (
          <Switch>
            <PublicRoute exact path={ROUTES?.LOGIN} component={Login} />
            <PublicRoute
              exact
              path={ROUTES?.VERIFY_USER}
              component={VerifyUser}
            />
            <Route
              exact
              path={`${ROUTES?.INSTALL}/:subLinkId`}
              component={PublicPage}
            />
            <Route exact path={ROUTES?.IOS_UDID} component={IosDeviceUdid} />
            <PrivateRoute
              exact
              path={ROUTES?.CREATE_USER}
              component={NewUser}
            />
            <PrivateRoute exact path={ROUTES?.LOGOUT} component={Logout} />
            <Route
              exact
              path={ROUTES?.REFRESH_TOKEN}
              component={RefreshToken}
            />
            <PrivateRoute path={ROUTES?.MAIN} component={App} />
          </Switch>
        )}
      </Router>
    </Sentry.ErrorBoundary>
  );
};
export default Routes;
